import React from "react";
import { PState } from "@firatoltulu/smartform";

import StatisticsBoard from "../Component/Statistics/StatisticsBoard";

/**
 * İstatistikler — birlik yöneticisinin açılış ekranı.
 *
 * Kartlar veriyi kendileri çeker; biri yavaşladığında ya da hata verdiğinde
 * diğerleri beklemez. Stiller AdminUI/src/assets/styles/dashboard/style.scss.
 */
const Statistics = (props) => {
  const { history } = props;
  const navigate = (path) => history && history.push(path);

  return (
    <PState id="Statistics" endPoint={{ baseURL: "/", method: "get" }}>
      <StatisticsBoard onNavigate={navigate} />
    </PState>
  );
};

export default {
  Component: Statistics,
  path: "/",
  exact: true,
};
